import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button, Image, Col, Row, Modal, Table } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { Toggle } from "../../superAdminReusable/reusableSuperAdminButton/Toggle";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import moment from "moment";
import isEmpty from "../../../../store/validation/is-Empty";
import {
  get_all_events,
  delete_event_admin,
} from "../../../../store/actions/SuperAdminActions/commonSuperAdmin";

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

const ViewEventDetailsOnline = ({
  onClickshowView,
  onClickCloseView,
  restaurantDetailFromOfferId,
  showOpenDeleteModel,
  closeDeleteModal,
  showDeleteEvent,
  deleteEventOnline,
}) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const [showLog, setShowLog] = useState(false);
  const [showMoreDetail, setShowMoreDetail] = useState(false);
  const [checked, setChecked] = useState(false);

  const token = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user.accessToken : "";
  });

  const toggleFunction = (e) => setChecked({ checked: !checked.checked });
  const handleShowLog = () => {
    setShowLog({
      showLog: !showLog.showLog,
    });
  };
  const handleShowMoreDetail = () => {
    setShowMoreDetail({
      showMoreDetail: !showMoreDetail.showMoreDetail,
    });
  };
  {
    console.log(restaurantDetailFromOfferId && restaurantDetailFromOfferId);
  }

  // const [showDeleteEvent, seShowDeleteEvent] = useState(false);
  // const handleCloseDeleteEvent = () => {
  //   seShowDeleteEvent(false);
  // };

  // const deleteEvent = (eventId) => {
  //   dispatch(delete_event_admin(token, eventId, onSuccessEdit));
  //   seShowDeleteEvent(false);
  // };

  // const onSuccessEdit = () => {
  //   dispatch(get_all_events(token, onSuccess));
  // };

  // const onSuccess = () => {
  //   // history.push("/superadminrestaurantevents");
  //   window.location.reload();
  // };

  return (
    <>
      <Modal
        show={onClickshowView}
        onHide={onClickCloseView}
        centered
        size="lg"
      >
        <Modal.Header className="border-0 px-md-4" closeButton>
          <Modal.Title className="f24-700">View Event Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-md-4">
          <div className="d-flex">
            <div className="enIMG75">
              <SimpleReactLightbox>
                <SRLWrapper options={options}>
                  <Image
                    src={
                      restaurantDetailFromOfferId &&
                      restaurantDetailFromOfferId.restaurant_id &&
                      restaurantDetailFromOfferId.restaurant_id.logo_url
                    }
                    alt={
                      restaurantDetailFromOfferId?.restaurant_id
                        ?.restaurant_name
                    }
                    title={
                      restaurantDetailFromOfferId?.restaurant_id
                        ?.restaurant_name
                    }
                    fluid
                    className="w-100 h-100"
                  />
                </SRLWrapper>
              </SimpleReactLightbox>
            </div>
            <div className="pl-3 row">
              <Col
                lg={10}
                xl={8}
                className="d-flex flex-column justify-content-between"
              >
                <div className="f24-500">
                  {restaurantDetailFromOfferId?.restaurant_id?.restaurant_name}
                </div>
                <div className="f14-400">
                  {
                    restaurantDetailFromOfferId?.restaurant_id
                      ?.restaurant_address
                  }
                </div>
              </Col>
            </div>
          </div>
          <hr />
          <div className="enGrayBorderBox">
            <Row className="px-4">
              <Col lg={7} md={12}>
                <Row>
                  <Col lg={8} md={6} className="py-3">
                    <div className="f12-500 pb-3">My Event</div>
                    <div className="d-flex align-items-center">
                      <div className="text-center d-flex flex-column align-items-center w-25">
                        <SimpleReactLightbox>
                          <SRLWrapper options={options}>
                            <Image
                              src={
                                restaurantDetailFromOfferId &&
                                restaurantDetailFromOfferId.photos &&
                                restaurantDetailFromOfferId.photos[0]
                              }
                              alt="View"
                              title="View"
                              fluid
                              className="w-100 h-100 rounded"
                            />
                          </SRLWrapper>
                        </SimpleReactLightbox>
                        <div className="enSuccessLBL mt-2">Online</div>
                      </div>
                      <div className="pl-3">
                        <div className="f14-500">
                          {restaurantDetailFromOfferId?.name}
                        </div>
                        <div className="f12-400">
                          {restaurantDetailFromOfferId?.description}
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={4} md={6} className="py-3">
                    <div className="f12-500 pb-3">Timing</div>
                    <div className="f12-500">
                      {moment(restaurantDetailFromOfferId?.start_date).format(
                        "hh:mm A"
                      )}
                    </div>
                    <div className="f12-500 pl-4 py-1">to</div>
                    <div className="f12-500">
                      {moment(restaurantDetailFromOfferId?.end_date).format(
                        "hh:mm A"
                      )}
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col lg={5} md={12}>
                <Row>
                  <Col md={6} className="py-3">
                    <div className="f12-500 pb-3">Start Date</div>
                    <div className="f12-500">
                      {moment(restaurantDetailFromOfferId?.start_date).format(
                        "Do MMM YY"
                      )}
                    </div>
                  </Col>
                  <Col md={6} className="py-3">
                    <div className="f12-500 pb-3">End Date</div>
                    <div className="f12-500 text-red">
                      {moment(restaurantDetailFromOfferId?.end_date).format(
                        "Do MMM YY"
                      )}
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col md={12}>
                <hr />
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Status</div>
                <div className="d-flex align-items-center">
                  <div className="f12-400 mr-2">
                    {restaurantDetailFromOfferId?.active
                      ? "Active"
                      : "Inactive"}
                  </div>
                  <Toggle
                    checked={restaurantDetailFromOfferId?.active}
                    toggleFunction={
                      () => {}
                      // toggleFunction
                    }
                  />
                </div>
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Primary</div>
                <div className="d-flex align-items-center">
                  <div
                    className={`${
                      restaurantDetailFromOfferId?.mark_as_primary
                        ? "f12-400 mr-2"
                        : "f12-500 mr-2"
                    }`}
                  >
                    No
                  </div>
                  <Toggle
                    checked={restaurantDetailFromOfferId?.mark_as_primary}
                    toggleFunction={
                      () => {}
                      // toggleFunction
                    }
                  />
                  <div
                    className={`${
                      restaurantDetailFromOfferId?.mark_as_primary
                        ? "f12-500 ml-2"
                        : "f12-400 ml-2"
                    }`}
                  >
                    Yes
                  </div>
                </div>
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Hyperlink</div>
                <div className="f14-400">
                  {restaurantDetailFromOfferId?.eventLink}
                </div>
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Coupon Code</div>
                <div className="f14-400">
                  {restaurantDetailFromOfferId?.eventPassword}
                </div>
              </Col>
              <Col md={12}>
                <hr />
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="d-flex align-items-center">
                  <NavLink
                    to="/superadminrestaurantevents/edit-online-event"
                    className="enIconBtn mr-3"
                  >
                    <Image
                      src={require("../../../../assets/images/UserManagement/pencil.svg")}
                      alt="Edit"
                      title="Edit"
                      fluid
                    />
                  </NavLink>
                  <Button
                    variant="link"
                    className="enIconBtn mr-3"
                    onClick={showOpenDeleteModel}
                  >
                    <Image
                      src={require("../../../../assets/images/UserManagement/Delete.svg")}
                      alt="Delete"
                      title="Delete"
                      fluid
                    />
                  </Button>
                </div>
              </Col>
              {/* <Col lg={4} md={8} className="py-3">
                <div className="f12-500 pb-3">Hyperlink</div>
                <div className="f14-400 enEllips">
                  Https://youtube/mCE2tqOfsDI{" "}
                </div>
              </Col>
              <Col lg={2} md={4} className="py-3">
                <div className="f12-500 pb-3">Event Code</div>
                <div className="f14-400">XXX </div>
              </Col> */}
            </Row>
          </div>
          <div className="pt-4 f12-400 opacity5">Event Name</div>
          <div className="d-flex align-items-center pt-2">
            <div className="f16-500">{restaurantDetailFromOfferId?.name}</div>
            <div className="enSuccessLBL ml-2">Online</div>
          </div>
          <div className="pt-4 f12-400 opacity5">Description</div>
          <div className="pt-2 f12-400">
            {restaurantDetailFromOfferId?.description}
          </div>
          <hr />
          <div className="pb-2 f12-400 opacity5">Kids Allowed</div>
          <div className="d-flex align-items-center">
            <div
              className={`${
                restaurantDetailFromOfferId?.isKidsAllowed
                  ? "f12-400 mr-2"
                  : "f12-500 mr-2"
              }`}
            >
              No
            </div>
            <Toggle
              checked={restaurantDetailFromOfferId?.isKidsAllowed}
              toggleFunction={
                () => {}
                // toggleFunction
              }
            />
            <div
              className={`${
                restaurantDetailFromOfferId?.isKidsAllowed
                  ? "f12-500 mr-2"
                  : "f12-400 mr-2"
              }`}
            >
              Yes
            </div>
          </div>
          <hr />
          <Row>
            <Col lg={3} md={6} className="my-3 border-right">
              <div className="pb-2 f12-400 opacity5">Start Date</div>
              <div className="d-flex align-items-center">
                <Image
                  src={require("../../../../assets/images/UserManagement/calendar.svg")}
                  alt="View"
                  title="View"
                  width="20px"
                  className="mr-2"
                />
                <div className="f16-700">
                  {" "}
                  {moment(restaurantDetailFromOfferId?.start_date).format(
                    "DD/MM/YYYY"
                  )}
                </div>
              </div>
            </Col>
            <Col lg={3} md={6} className="my-3 border-right">
              <div className="pb-2 f12-400 opacity5">Start Time</div>
              <div className="d-flex align-items-center">
                <div className="f16-700">
                  {moment(restaurantDetailFromOfferId?.start_date).format(
                    "hh:mm A"
                  )}
                </div>
              </div>
            </Col>
            <Col lg={3} md={6} className="my-3 border-right">
              <div className="pb-2 f12-400 opacity5">End Date</div>
              <div className="d-flex align-items-center">
                <Image
                  src={require("../../../../assets/images/UserManagement/calendar.svg")}
                  alt="View"
                  title="View"
                  width="20px"
                  className="mr-2"
                />
                <div className="f16-700">
                  {moment(restaurantDetailFromOfferId?.end_date).format(
                    "DD/MM/YYYY"
                  )}
                </div>
              </div>
            </Col>
            <Col lg={3} md={6} className="my-3">
              <div className="pb-2 f12-400 opacity5">End Time</div>
              <div className="d-flex align-items-center">
                <div className="f16-700">
                  {moment(restaurantDetailFromOfferId?.end_date).format(
                    "hh:mm A"
                  )}
                </div>
              </div>
            </Col>
            <Col lg={3} md={4} className="my-3">
              <div className="pb-2 f12-400 opacity5">Coupon Code</div>
              <div className="f16-700">
                {restaurantDetailFromOfferId?.eventPassword}
              </div>
            </Col>
            <Col lg={6} md={4} className="my-3">
              <div className="pb-2 f12-400 opacity5">Hyperlink</div>
              <div className="f16-700 enEllips">
                {restaurantDetailFromOfferId?.eventLink}
              </div>
            </Col>
            {/* <Col lg={3} md={4} className="my-3">
              <div className="pb-2 f12-400 opacity5">Password(if any)</div>
              <div className="f16-700">
              <input id="passwordField" type="password" name="passwordField" value="" autocomplete="off" />
                {restaurantDetailFromOfferId?.eventPassword}
                </div>
            </Col> */}
          </Row>
          <hr />
          {/* <div className="pt-4 f12-400 opacity5">Venue /Address / Location</div>
          <div className="pt-2 pb-4 f12-400">
            This is one of the best Offers you can get in your life , visit this
            place if you want to Have a time of your life, food here Is
            awesomeThis is one of the best Offers you can get in your life ,
            visit this plac
          </div> */}
          <div className="pb-4">
            <div className="pb-2 f12-400 opacity5">Event Photo</div>
            <div className="enIMG105">
              {restaurantDetailFromOfferId?.photo_thumbnails &&
                restaurantDetailFromOfferId?.photo_thumbnails.map(
                  (item, index) => {
                    return (
                      <React.Fragment key={index}>
                        <SimpleReactLightbox>
                          <SRLWrapper options={options}>
                            <Image
                              src={item}
                              alt="Offer Picture"
                              title="Offer Picture"
                              fluid
                              className="w-100 h-100 img-fluid img-thumbnail"
                            />
                          </SRLWrapper>
                        </SimpleReactLightbox>
                      </React.Fragment>
                    );
                  }
                )}
            </div>
            {/* <div className="pt-2 f12-400">
              (You can upload only 1 pic per offer 700 x 420 pixels)
            </div> */}
          </div>
          <div className="pb-4">
            <div className="pb-2 f12-400 opacity5">Offer Video</div>
            <div className="enIMG105">
              {restaurantDetailFromOfferId?.videos === "" ? (
                <p className="text-red f14-500">Video Not Available</p>
              ) : restaurantDetailFromOfferId?.videos !== undefined &&
                restaurantDetailFromOfferId?.videos !== null ? (
                <div className="">
                  <video
                    width="100%"
                    height="100%"
                    controls
                    src={restaurantDetailFromOfferId?.videos}
                    type="video/mp4"
                  />
                </div>
              ) : null}
            </div>
            {/* <div className="pt-2 f12-400">
              (You can upload only 1 pic per offer 700 x 420 pixels)
            </div> */}
          </div>
          <div className="pb-4">
            <div className="f12-400 opacity5">Terms and Conditions</div>
            <div className="pt-2 f12-400">
              {restaurantDetailFromOfferId?.terms_and_condition}
            </div>
          </div>

          <hr />
          <div>
            <Button
              variant="link"
              onClick={handleShowMoreDetail}
              className="f18-700 px-0 pb-3 text-dark"
            >
              View more details{" "}
              <Image
                src={require("../../../../assets/images/UserManagement/up-arrow.svg")}
                alt="offer"
                title="offer"
                fluid
                width="15px"
                className={`ml-2 ${
                  !showMoreDetail.showMoreDetail ? "en180deg" : ""
                }`}
              />
            </Button>
          </div>
          {showMoreDetail.showMoreDetail && (
            <div className="enGrayBorderBox">
              <Row className="px-4">
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Phone Number</div>
                  <div className="f14-400">
                    {/* {restaurantDetailFromOfferId?.restaurant_id
                      ?.contact_detail &&
                    restaurantDetailFromOfferId?.restaurant_id?.contact_detail
                      .length <= 0
                      ? "-"
                      : restaurantDetailFromOfferId?.restaurant_id?.contact_detail.map(
                          (item, index) => {
                            if (index === 0) {
                              return item.country_code + item.mobile_no;
                            } else if (item) {
                              return ", " + item.country_code + item.mobile_no;
                            }
                          }
                        )} */}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Event ID</div>
                  <div className="f14-400">
                    #{restaurantDetailFromOfferId?.event_id}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Start Date / Time</div>
                  <div className="f14-400">
                    {moment(restaurantDetailFromOfferId?.start_date).format(
                      "Do MMM YYYY"
                    )}
                  </div>
                  <div className="f14-400">
                    {moment(restaurantDetailFromOfferId?.start_date).format(
                      "hh:mm A"
                    )}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">End Date / Time</div>
                  <div className="f14-400">
                    {moment(restaurantDetailFromOfferId?.end_date).format(
                      "Do MMM YYYY"
                    )}
                  </div>
                  <div className="f14-400">
                    {moment(restaurantDetailFromOfferId?.end_date).format(
                      "hh:mm A"
                    )}
                  </div>
                </Col>
                <Col md={12}>
                  <hr />
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Changed Date / Time</div>
                  <div className="f14-400">
                    {moment(restaurantDetailFromOfferId?.updatedAt).format(
                      "Do MMM YYYY"
                    )}
                  </div>
                  <div className="f14-400">
                    {moment(restaurantDetailFromOfferId?.updatedAt).format(
                      "hh:mm A"
                    )}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Created Date / Time</div>
                  <div className="f14-400">
                    {" "}
                    {moment(restaurantDetailFromOfferId?.createdAt).format(
                      "Do MMM YYYY"
                    )}
                  </div>
                  <div className="f14-400">
                    {" "}
                    {moment(restaurantDetailFromOfferId?.createdAt).format(
                      "hh:mm A"
                    )}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Pont of Entry</div>
                  <div className="f14-400">Menually Added</div>
                </Col>
                {/* <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Maximum Usage Limit</div>
                  <div className="f14-400">100</div>
                </Col> */}
              </Row>
            </div>
          )}
          <hr />
          <Button
            variant="link"
            onClick={handleShowLog}
            className="f18-700 px-0 pb-3 text-dark"
          >
            View Audit Log{" "}
            <Image
              src={require("../../../../assets/images/UserManagement/up-arrow.svg")}
              alt="offer"
              title="offer"
              fluid
              width="15px"
              className={`ml-2 ${!showLog.showLog ? "en180deg" : ""}`}
            />
          </Button>
          {showLog.showLog && (
            <div className="enGrayBorderBox">
              <Table responsive className="enAuditLogTBL">
                <tr>
                  <th className="">
                    <div className="f12-500">Date</div>
                  </th>
                  <th>
                    <div className="f12-500">Operation</div>
                  </th>
                  <th></th>
                </tr>
                {restaurantDetailFromOfferId?.auditLogs &&
                  restaurantDetailFromOfferId?.auditLogs.map((data, index) => {
                    return (
                      <React.Fragment key={index}>
                        <tr>
                          <td>
                            <div className="f12-500">
                              {moment(data.timestamp).format("Do MMMM, YYYY")}
                            </div>
                            <div className="f12-500">
                              {moment(data.timestamp).format("hh:mm A")}
                            </div>
                          </td>
                          <td>
                            <div className="f12-500">{data.message}</div>
                          </td>
                          <td>
                            <div className="f12-500">{data.initiator}</div>
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  })}
              </Table>
            </div>
          )}
        </Modal.Body>
      </Modal>
      <React.Fragment>
        <Modal show={showDeleteEvent} onHide={closeDeleteModal} centered>
          <Modal.Header className="py-0 pt-2 border-0" closeButton>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body className="f16-500">
            Are you sure to Delete the Event ?
          </Modal.Body>
          <Modal.Footer className="justify-content-start border-0">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5"
              onClick={closeDeleteModal}
            >
              No
            </Button>
            <Button
              variant="danger"
              className="btn-lg px-5"
              onClick={deleteEventOnline}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    </>
  );
};
export default ViewEventDetailsOnline;
